<template>
  <div class="login-wrapper border border-light">
    <p>{{ err }}</p>
    <vue-rvc-login
      api-endpoint="api/auth.cfc"
      app-name="Room Schedule"
      @success="success"
      @fail="clear"
    ></vue-rvc-login>
  </div>
</template>

<script>
import {VueRvcLogin} from 'vue-rvc-login';
export default {
    name: 'Login',
    components: {
        VueRvcLogin
    },
    props: {
        loginAction: {default: 'login'},
        logoutAction: {default: 'logout'}
    },
    methods: {
        success(data) {
            localStorage[this.$store.getters.appToken] = data.token;
            if (data.success) {
                this.$store.dispatch(this.loginAction);
                this.$router.replace(this.$route.query.destination || '/');
            }
        },
        clear() {
            delete localStorage[this.$store.getters.appToken]; // eslint-disable-line prefer-reflect
            this.$store.dispatch(this.logoutAction);
        }
    }
};
</script>